<template>
  <b-container fluid class="p-0">
    <register />
  </b-container>
</template>

<script>
import Register from '@/components/Client/Register/index.vue';

export default {
  components: {
    Register
  }
}
</script>
